import { createApp } from 'vue';
import EditHikeDetailsApp from './EditHikeDetailsApp.vue';

// Only mounts when the owner-gated mount point is present on the page.
const el = document.getElementById('edit-hike-details');
if (el) {
  createApp(EditHikeDetailsApp).mount('#edit-hike-details');
}
